import { type Dispatch } from 'react';

import { type ChatStreamHandlers } from '../../services/api/ai';

import { type ConversationAction } from './conversation-reducer';
import { turnFlagForStatusKey } from './turn-flags';
import { type StreamStatus } from './constants';

export const createStreamCallbacks = ({
  dispatch,
  generation,
  messageId,
  pushStatus,
  isStaleTurn,
  onHandoffRequested,
}: {
  dispatch: Dispatch<ConversationAction>;
  generation: number;
  messageId: string;
  pushStatus: (status: { key: string; text: string }) => StreamStatus | null;
  isStaleTurn: () => boolean;
  onHandoffRequested: () => void;
}): ChatStreamHandlers => ({
  onChunk: (chunk) => {
    dispatch({ type: 'turn/chunk', generation, messageId, chunk });
  },

  onStatus: (status) => {
    if (isStaleTurn()) return;
    if (typeof status.text !== 'string') return;

    const accepted = pushStatus(status);
    if (!accepted) return;

    const flag = turnFlagForStatusKey(accepted.key);
    if (flag) {
      dispatch({ type: 'turn/flag', generation, messageId, flag });
    }
  },

  onSuggestedActions: (actions) => {
    dispatch({ type: 'turn/suggestedActions', generation, messageId, actions });
  },

  onOutfitSlotReady: (event) => {
    dispatch({ type: 'turn/outfitProduct', generation, messageId, ...event });
  },

  onProductCardReady: (event) => {
    dispatch({
      type: 'turn/productCard',
      generation,
      messageId,
      card: event.card,
      totalExpected: event.totalExpected,
    });
  },

  onHandoffStatus: (handoffStatus) => {
    if (isStaleTurn()) return;
    if (handoffStatus) onHandoffRequested();
  },

  onEmailDraft: (draft) => {
    dispatch({ type: 'turn/emailDraft', generation, messageId, draft });
  },
});
